import React from 'react';
import SEOHead from './SEOHead';
import LandingFooter from './LandingFooter';
import './landing.css';

const serif = { fontFamily: '"DM Serif Display", Georgia, serif' };
const ACCENT = '#1a5fff';

const SECTIONS = [
  { title: '1. Acceptance of Terms', body: [
    'By creating an account or using DigiHR, you agree to be bound by these Terms of Service and our Privacy Policy. If you are accepting on behalf of a company, you represent that you have authority to bind that company.',
  ]},
  { title: '2. The Service', body: [
    'DigiHR provides a cloud-based Human Resource Management System (HRMS) including modules for attendance, payroll, leave, performance, L&D, expense claims, rewards, asset tracking and policy management. The specific features available to you depend on your subscription plan.',
  ]},
  { title: '3. Accounts & Access', body: [
    'You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account. You must notify us immediately at hello@digihr.in if you suspect unauthorised access.',
    'You may not share login credentials across multiple individuals. Each named user must have their own account.',
  ]},
  { title: '4. Payment & Billing', body: [
    'Subscription fees are charged monthly in advance on the 1st of each month, based on the number of active employees. Prices are listed in Indian Rupees (INR) and are exclusive of applicable GST. Failure to pay within 14 days of the due date may result in service suspension.',
  ]},
  { title: '5. Free Trial', body: [
    'New customers receive a 30-day free trial with full access to all features on their chosen plan. No credit card is required to start a trial. At the end of the trial, your account will move to a paid subscription unless you cancel.',
  ]},
  { title: '6. Acceptable Use', body: [
    'You agree not to use DigiHR to store unlawful content, attempt to reverse-engineer the platform, probe for security vulnerabilities, or resell access to third parties without our written consent. We reserve the right to suspend accounts that violate these terms.',
  ]},
  { title: '7. Data Ownership', body: [
    'You own your data. We process it only as directed by you to provide the service. On cancellation, you may export your data at any time within 90 days. After 90 days, data may be permanently deleted in accordance with our retention policy.',
  ]},
  { title: '8. Service Availability', body: [
    'We target 99.9% monthly uptime for the DigiHR platform. Planned maintenance windows will be communicated at least 48 hours in advance. Enterprise plan customers are covered by a formal SLA with service credit provisions.',
  ]},
  { title: '9. Limitation of Liability', body: [
    'To the maximum extent permitted by law, Sciverse Solutions Pvt. Ltd. shall not be liable for indirect, incidental or consequential damages arising from your use of DigiHR. Our total liability in any month shall not exceed the fees paid by you in that month.',
  ]},
  { title: '10. Governing Law', body: [
    'These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts of Pune, Maharashtra.',
  ]},
];

const Terms = () => (
  <>
    <SEOHead
      title="Terms of Service — DigiHR"
      description="Terms of Service governing your use of the DigiHR platform, operated by Sciverse Solutions Pvt. Ltd."
      canonical="/terms"
    />

    {/* Page Hero */}
    <section style={{ padding: '60px 5% 52px', background: 'linear-gradient(160deg,#f0f4ff 0%,#ffffff 100%)', borderBottom: '1px solid #e4e7ed' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 12, fontWeight: 500, color: ACCENT, letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 12 }}>Legal</div>
        <h1 style={{ ...serif, fontSize: 'clamp(36px,4.5vw,56px)', lineHeight: 1.1, letterSpacing: '-.03em', color: '#0d1117', maxWidth: 600, marginBottom: 16 }}>
          Terms of <em style={{ fontStyle: 'italic', color: ACCENT }}>Service</em>
        </h1>
        <p style={{ fontSize: 17, color: '#3a3f4a', lineHeight: 1.65, maxWidth: 520 }}>Last updated: 1 June 2026. These terms govern your use of the DigiHR platform, operated by Sciverse Solutions Pvt. Ltd.</p>
      </div>
    </section>

    <section style={{ padding: '80px 5%' }}>
      <div style={{ maxWidth: 760, margin: '0 auto' }}>
        {SECTIONS.map(({ title, body }) => (
          <div key={title} style={{ marginBottom: 40 }}>
            <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 12 }}>{title}</h3>
            {body.map((p, i) => (
              <p key={i} style={{ fontSize: 15, color: '#3a3f4a', lineHeight: 1.8, marginBottom: i < body.length - 1 ? 10 : 0 }}>{p}</p>
            ))}
          </div>
        ))}

        <div style={{ padding: 24, background: '#f6f7f9', borderRadius: 20, border: '1px solid #e4e7ed' }}>
          <p style={{ fontSize: 14, color: '#3a3f4a', lineHeight: 1.7 }}>
            <strong>Questions about these terms?</strong> Write to us at <strong>legal@digihr.in</strong> or by post to Sciverse Solutions Pvt. Ltd., Office No. 307, Sr No. 18/2 A V18, Pune, Maharashtra 411045, India.
          </p>
        </div>
      </div>
    </section>

    <LandingFooter />
  </>
);

export default Terms;
